const LINKS = [
  {
    to: '/yearbook',
    i18n: {
      id: 'Nav.yearbook',
      defaultMessage: 'Yearbook'
    }
  }
]

export default LINKS



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/components/NavBar/components/Nav/config/links.js